import { FORM_ERROR_MESSAGES } from "Constant";
import { format } from "date-fns";
import { useMasterLocation } from "hook/useMasterLocation";
import { GENDERES, genderOptions } from "pages/users/constant";
import { TableColumn } from "react-data-table-component";
import { UseFormReturn } from "react-hook-form";

export const tableColumns: TableColumn<any>[] = [
  {
    name: "Họ và tên",
    selector: ({ hoTen }) => hoTen,
  },
  {
    name: "Ngày sinh",
    selector: ({ ngaySinh }) =>
      ngaySinh ? format(ngaySinh, "dd-MM-yyyy") : "",
  },
  {
    name: "Giới tính",
    selector: ({ gioiTinh }) => GENDERES[+gioiTinh],
  },
  {
    name: "Số CCCD",
    selector: ({ cccd }) => cccd,
  },
  {
    name: "Ngày cấp CCCD",
    selector: ({ ngayCapCCCD }) =>
      ngayCapCCCD ? format(ngayCapCCCD, "dd-MM-yyyy") : "",
  },
  {
    name: "Nơi cấp CCCD",
    selector: ({ noiCapCCCD }) => noiCapCCCD,
  },
  {
    name: "Số điện thoại",
    selector: ({ soDienThoai }) => soDienThoai,
  },
  {
    name: "Địa chỉ",
    selector: ({ diaChiChiTiet }) => diaChiChiTiet,
  },
  {
    name: "Ghi chú",
    selector: ({ ghiChu }) => ghiChu || "",
  },
];

export const useFormFields = (useFormReturn?: UseFormReturn) => {
  const { watch } = useFormReturn || {};
  const { formFields } = useMasterLocation({
    quanHuyen: watch?.("masterQuanHuyenId"),
    tinhThanhPho: watch?.("masterTinhThanhPhoId"),
  });

  return [
    {
      name: "hoTen",
      label: "Họ và tên",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "ngaySinh",
      label: "Ngày sinh",
      type: "date",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "gioiTinh",
      label: "Giới tính",
      type: "radio",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
      options: genderOptions,
    },
    {
      name: "cccd",
      label: "Số CCCD",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
        pattern: {
          value: /^\d{12}$/,
          message: "CCCD phải có 12 chữ số",
        },
      },
    },
    {
      name: "ngayCapCCCD",
      label: "Ngày cấp CCCD",
      type: "date",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "noiCapCCCD",
      label: "Nơi cấp CCCD",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "soDienThoai",
      label: "Số điện thoại",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
        pattern: {
          value: /^[0-9]{10,11}$/,
          message: "Số điện thoại không hợp lệ",
        },
      },
    },
    {
      name: "diaChiChiTiet",
      label: "Địa chỉ",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    ...formFields,
    {
      name: "ghiChu",
      label: "Ghi chú",
      type: "text",
    },
  ] as any;
};

export const title = "Danh sách người dùng";
export const parent = "Quản lý tài khoản";
